import React, { useState } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const answer1 = `
    Get reliable and affordable logistics services from the Parsal app by following these steps:
    <br/>1. Sign in to the Parsal app
    <br/>2. Choose the service you want - trucks, 2wheeler or intercity courier services.
    <br/>3. Set your pick-up and drop-off location.
    <br/>4. Browse through the list of available vehicles (Tata Ace, Pickup 8ft, 2wheeler etc.) and pick the one that suits your moving needs.
    <br/>5. Enter a few additional details, apply coupons to get exciting discounts, and confirm your booking.
    <br/>6. Sit back and relax - our verified driver partners will do the rest.
  `;

  const faqs = [
    {
      question: "What is Parsal App?",
      answer:
        "Parsal is a tech-enabled logistics company offering a variety of intracity and intercity delivery services. Just download and register yourself on the app, choose the service that best fits your logistics needs and make your booking! With Parsal, you will get a verified driver and vehicle right at your doorstep.",
    },
    {
      question: "How do I use Parsal App?",
      answer:
        "Follow these simple steps to start leveraging hassle-free logistics from Parsal:1.Download the Parsal app 2.Choose the service you want to use 3.Select your pick up and delivery locations 4.Add any extra stops, if applicable 5.Choose the most appropriate vehicle type as per your requirements (2wheeler, three-wheelers or trucks) 6.Select the type of goods you’re sending 7.Choose your payment method 8.Click on “Book Now” and your vehicle is on its way!",
    },
    {
      question:
        "How do I book a tempo/mini truck/bike or intercity courier services online from the Parsal app?",
      answer: answer1,
    },
    {
      question: "Does Parsal provide intercity or interstate service?",
      answer:
        "Parsal provides intracity & intercity services. For instant goods delivery within the city, you can choose Parsal 2-wheelers and trucks. We also have intercity outstation services within a 300km radius of the city center. You can also send goods across India with Parsal intercity courier services at economical rates. Parsal also provides intercity and intracity house shifting services.",
    },
    {
      question: "What are the items that are prohibited by Parsal?",
      answer:
        "Pornographic material, Dry ice used for packaging or temperature control, Human corpses, organs, or body parts, Flammable items (firecrackers, oil cans, adhesives, paint cans), explosives (arms, ammunition, fireworks, flares, gunpowder, airbag inflators), Fire extinguishers, Alcohol, tobacco, medicines, drugs, contraband, narcotics, psychotropic substances, poisonous goods, toxic and infectious items, Passports, antiques, works of art, High-capacity batteries such as car batteries, generator batteries, machinery parts containing oil, grease, fuel, or batteries, Corrosive items such as acids, chemicals, etc., Radioactive material, Fragile items, Highly perishable food items, LEDs, LCDs, plasma, OLED, and any kind of television screens, Liquid product, Expensive electronics, mobile phones, iPads, laptops, smart watches, etc., Livestock, Pets and animals, Perishables, Platinum, gold, silver, jewelry, gems, precious and semi-precious metals or stones in any form, Indian postal articles such as stamps and articles like coins, banknotes, currency notes, Sodexo or securities of any kind payable to bearer, traveler’s cheques, credit/debit/ATM cards, Gambling devices, lottery tickets, Any diagnostic specimens, hazardous or bio-medical waste, Sensitive documents.",
    },
    {
      question:
        "What are the charges for a Parsal truck and Parsal bike delivery service?",
      answer:
        "The charges for hiring a Parsal truck or bike are based on the number of kilometres travelled and the type of vehicle chosen and this differs from locality to locality. You can also check the estimate tab on the Parsal website to get an exact idea of your final trip amount. Alternatively, the final trip amount can be determined when making the booking on the app.",
    },
    {
      question: "Does Parsal provide Packers and Movers services?",
      answer:
        "Yes, Parsal caters to all kinds of house shifting needs through Parsal Packers & Movers. If you have an immediate moving requirement, we also have the option to hire a mini truck with labour. Intracity shifting services through Parsal Packers and Movers is available in Mumbai, Delhi NCR, Bangalore, Hyderabad, Chennai, Pune, Kolkata, Ahmedabad, Surat, Coimbatore, Indore, Jaipur, Lucknow and Nagpur. Intercity Packers and Movers services can be availed between any of the following cities - Mumbai, Delhi NCR, Bangalore, Hyderabad, Chennai, Pune, Kolkata and Ahmedabad. If you don’t see your city in the above list, don’t worry; the service will be launching soon in other cities. To enquire about Parsal Packers and Movers or avail the service, call 4410 4410 (add your city code).",
    },
    {
      question: "What does Parsal deliver?",
      answer:
        "From a pin to an entire house, we will deliver anything, anywhere, anytime. However, Parsal does not deliver item(s) which are Prohibited Items.",
    },
    {
      question: "How long does it take to deliver?",
      answer:
        "In the case of intracity deliveries, the distance & traffic play a major role in determining the delivery time however the instant availability of vehicles allows you to send goods up to 2500 kgs. Parsal intercity courier services allows you to deliver goods at economical rates within a couple of days.",
    },
    {
      question:
        "Does Parsal provide mini trucks like tata ace on monthly contract?",
      answer:
        "We provide on-demand availability of mini trucks like Tata Ace. For bulk orders and frequent uses, we provide Parsal for Enterprise service with one app-multi-city-mutli user access.",
    },
  ];

  return (
    <div className="w-[85vw] mlg:w-[92vw] smp:w-[95vw] mx-auto inter">
      <div className="bg-[#FFFFFF] py-10 flex flex-col items-center">
        <h2 className="text-[30px] sm:text-2xl inter font-bold mb-2">
          Frequently Asked Questions
        </h2>
        <h4 className="text-[#777777] inter mb-8 text-center text-[16px] font-semibold sm:text-[14px] xs:text-[12px]">
          In case you have more questions, feel free to reach out to us.
        </h4>
        <div className="w-[60%] xxl:w-[80%] mx-auto mdg:w-[100%]">
          {faqs.map((faq, index) => (
            <div key={index} className="border-t border-gray-200">
              <button
                className="w-full text-left py-4 px-4 smp:px-2 flex justify-between items-center"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-[18px] text-[#232323] font-normal">
                  {faq.question}
                </span>
                <span>
                  {openIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </span>
              </button>
              {openIndex === index && (
                <div
                  className=" text-[#777777] font-normal px-4 pb-2"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
